module.exports = __webpack_public_path__ + "static/media/accesories.b738fbd2.jpeg";